import { RouteObject } from 'react-router-dom'
import MarketingPage from '../__legacy__/components/landing/MarketingPage'

// TODO: Refactor component such a way, that it lives under features and is called landing
const LandingPage = MarketingPage

export const LandingRoute: RouteObject = {
  path: '/studio-landing',
  element: <LandingPage />
}
